/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MDIStrictHttpResponse } from '../../mdi-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PublicHolidayRecordModel } from '../../models/public-holiday-record-model';

export interface PublicHolidayIdGet$Params {
  id: string;
}

export function publicHolidayIdGet(http: HttpClient, rootUrl: string, params: PublicHolidayIdGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<PublicHolidayRecordModel>> {
  const rb = new RequestBuilder(rootUrl, publicHolidayIdGet.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MDIStrictHttpResponse<PublicHolidayRecordModel>;
    })
  );
}

publicHolidayIdGet.PATH = '/PublicHoliday/{id}';
